import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn", "panel"]

  connect() {
    this.showTab(0)
  }

  select(event) {
    const index = this.btnTargets.indexOf(event.currentTarget)
    this.showTab(index)
  }

  showTab(index) {
    this.btnTargets.forEach((btn, i) => {
      if (i === index) {
        btn.classList.add("bg-slate-900", "text-white")
        btn.classList.remove("bg-white", "text-slate-600", "hover:bg-slate-50")
      } else {
        btn.classList.remove("bg-slate-900", "text-white")
        btn.classList.add("bg-white", "text-slate-600", "hover:bg-slate-50")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.hidden = (i !== index)
    })
  }
}
